import {AnchorHTMLAttributes} from 'react';

import {Link as RouterLink, LinkProps, NavLink as RouterNavLink, NavLinkProps} from 'react-router-dom';
import styled, {css} from 'styled-components';

import {Flex} from 'components/base/Flex';
import {withAnalyticsID} from 'shared/Ensighten/components/withAnalyticsID';
import {DataIDOptionalParams} from 'shared/Ensighten/types';
import {FontWeight, Breakpoints} from 'styles/Base';
import {Colors} from 'styles/Colors';

const ACTIVE_LINK_BORDER_WIDTH = '2px';

type AnalyticsLinkProps = LinkProps & DataIDOptionalParams;

type AnalyticsNavLinkProps = NavLinkProps & DataIDOptionalParams;

type AnalyticsAnchorProps = AnchorHTMLAttributes<any> & DataIDOptionalParams;

export const mobileNavLinkStyles = css<{isActive: boolean}>`
  align-items: center;
  display: flex;
  font-size: 0.875rem;
  font-weight: ${FontWeight.REGULAR};
  height: 35px;
  text-decoration: none;
  width: calc(100% - ${ACTIVE_LINK_BORDER_WIDTH});
  border-right: ${({isActive}) => isActive && `${ACTIVE_LINK_BORDER_WIDTH} solid ${Colors.BURNT_ORANGE}`};
  color: ${({isActive}) => (isActive ? Colors.BURNT_ORANGE : Colors.NEAR_BLACK)};
`;

const linkStyles = `
  color: ${Colors.JUNIPER};
  text-decoration: underline;
  transition: all 250ms ease;

  &:hover {
    color: ${Colors.VERY_DARK_CYAN};
  }
`;

export const StyledCardLink = styled(Flex)`
  align-items: flex-end;

  ${`@media (${Breakpoints.MOBILE})`} {
    align-items: flex-start;
    flex-direction: column;
  }
`;

const BaseLink = styled(RouterLink)`
  ${linkStyles};
`;

const BaseExternalLink = styled.a`
  ${linkStyles};
`;

/**
 * @deprecated use <Action
   name={'text-router'}
   actionType={ActionType.EXTERNAL}
   actionStyle={ActionStyle.TEXT}
   typeProps={{href: 'http://www.google.com'}}>
 */
export const ExternalLink = withAnalyticsID<AnalyticsAnchorProps>(BaseExternalLink);

const BaseNavLink = styled(RouterNavLink)`
  ${linkStyles};
`;

export const NavLink = withAnalyticsID<AnalyticsNavLinkProps>(BaseNavLink);

const Link = withAnalyticsID<AnalyticsLinkProps>(BaseLink);

export default Link;
